import { DateTime } from 'luxon';
import { useQuery } from 'react-query';
import { buildEndpoint } from '../endpoints';
import { apifetch } from '../robotapi';

export interface PensionCalcData {
    taxBracketAmount1?: number;
    taxBracketAmount2?: number;
    employedTaxPercentageDisc1?: number;
    employedTaxPercentageDisc2?: number;
    employedTaxPercentageDisc3?: number;
    retiredTaxPercentageDisc1?: number;
    retiredTaxPercentageDisc2?: number;
    retiredTaxPercentageDisc3?: number;
    nationalInsurancePremiumPercentage?: number;
    retiredNationalInsurancePremiumPercentage?: number;
    maximumPremiumIncomeAmount?: number;
    generalTaxCreditDiscountAmountLowerLimit?: number;
    generalTaxCreditDiscountAmountUpperLimit?: number;
    employedGeneralTaxCreditDiscountpercentage?: number;
    employedGeneralTaxCreditMinimumDiscountAmount?: number;
    retiredGeneralTaxCreditDiscountpercentage?: number;
    retiredGeneralTaxCreditMinimumDiscountAmount?: number;
    elderlyDiscountAmountLowerLimit?: number;
    elderlyDiscountAmountUpperLimit?: number;
    elderlyDiscountPercentage?: number;
    minimumElderlyDiscountAmount?: number;
    singleElderlyDiscountAmount?: number;
    healthInsuranceUpperLimit?: number;
    healthInsuranceEmployedPercentage?: number;
    healthInsuranceRetiredPercentage?: number;
    healthInsuranceSelfEmployedPercentage?: number;
    employedDisountTaxBracketAmount1?: number;
    employedDisountTaxBracketAmount2?: number;
    employedDisountTaxBracketAmount3?: number;
    employedDisountTaxBracketAmount4?: number;
    employedDisountTaxBracketPercentage1?: number;
    employedDisountTaxBracketPercentage2?: number;
    employedDisountTaxBracketPercentage3?: number;
    employedDisountTaxBracketPercentage4?: number;
    retiredDisountTaxBracketPercentage1?: number;
    retiredDisountTaxBracketPercentage2?: number;
    retiredDisountTaxBracketPercentage3?: number;
    retiredDisountTaxBracketPercentage4?: number;
    singleAOWAmount?: number;
    livingTogetherAOWAmount?: number;
    maximumAOWAgeInMonths?: number;
    aowFranchise?: number;
    maximumPensionFoundation?: number;
    premiumPercentagePensionFoundation?: number;
    maximumYearSpace?: number;
    pensionGrowthFactor?: number;
    marketRate?: number;
}

const getPensionCalcDataUrl = (year: number) => buildEndpoint(['pensioncalcdata', year.toString()]);

const getPensionCalcDataApiCall = (year: number) =>
    apifetch<PensionCalcData>(getPensionCalcDataUrl(year), 'GET');

export const useGetPensionCalcData= (year: number = DateTime.now().year) => {
    const query = useQuery<PensionCalcData>(['pensioncalcdata', year], async () => {
        return getPensionCalcDataApiCall(year)();
    },
    {
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });

    return query;
};